import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@app/core/graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    PakmailCarrier,
    CreatePakmailCarrierInput,
    UpdatePakmailCarrierInput,
    DeletePakmailCarrierInput,
    ModelPakmailCarrierFilterInput
} from '@app/core/services/api/API.service';

@Injectable({
    providedIn: 'root'
})
export class PakmailCarrierService {
    private amplifyClient = generateClient();
    constructor() {}

    async listPakmailCarriers(
        filter: ModelPakmailCarrierFilterInput = null
    ): Promise<PakmailCarrier[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listPakmailCarriers,
                    variables: {
                        filter
                    }
                })
            ).data.listPakmailCarriers.items;
            if (data) return data as PakmailCarrier[];
        } catch (error) {
            console.error('Error finding listPakmailCarriers:', error);
            return null;
        }
    }

    async createPakmailCarrier(
        input: CreatePakmailCarrierInput
    ): Promise<PakmailCarrier> {
        try {
            const pakmailCarrier = (
                await this.amplifyClient.graphql({
                    query: mutations.createPakmailCarrier,
                    variables: {
                        input
                    }
                })
            ).data.createPakmailCarrier;
            if (pakmailCarrier) return pakmailCarrier as PakmailCarrier;
        } catch (error) {
            console.error('Error creating PakmailCarrier:', error);
            return null;
        }
    }

    async updatePakmailCarrier(
        input: UpdatePakmailCarrierInput
    ): Promise<PakmailCarrier | null> {
        try {
            console.log('Sending data to update carrier:', input);

            const response = await this.amplifyClient.graphql({
                query: mutations.updatePakmailCarrier,
                variables: { input }
            });

            const pakmailCarrier = response?.data?.updatePakmailCarrier;
            if (pakmailCarrier) {
                console.log('Carrier updated successfully:', pakmailCarrier);
                return pakmailCarrier as PakmailCarrier;
            } else {
                console.error('No carrier returned from update mutation');
                return null;
            }
        } catch (error) {
            console.error('Error updating PakmailCarrier:', error);
            return null;
        }
    }

    async deletePakmailCarrier(
        input: DeletePakmailCarrierInput
    ): Promise<PakmailCarrier> {
        try {
            const pakmailCarrier = (
                await this.amplifyClient.graphql({
                    query: mutations.deletePakmailCarrier,
                    variables: {
                        input
                    }
                })
            ).data.deletePakmailCarrier;
            if (pakmailCarrier) return pakmailCarrier as PakmailCarrier;
        } catch (error) {
            console.error('Error deleting PakmailCarrier:', error);
            return null;
        }
    }
}
